<div *ngIf="!regionId && selectionMode!=='embedded'" class="stick-top">
  <mat-toolbar>
    <mat-icon>shield_person</mat-icon>
    Secure Access Users
  </mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button *ngIf="filter.hasService === 'true'"
            mat-raised-button class="primary"
            (click)="revokeSecureAccess()"
            [disabled]="!auth.hasRole('SITE_ACCESS_ADMIN') || selectedUserIds.length === 0">
      <mat-icon>gpp_bad</mat-icon>
      Revoke Secure Access
    </button>
    <button *ngIf="filter.hasService !== 'true'"
            mat-raised-button class="primary"
            (click)="enableSecureAccess()"
            [disabled]="!auth.hasRole('SITE_ACCESS_ADMIN') || selectedUserIds.length === 0">
      <mat-icon>verified_user</mat-icon>
      Enable Secure Access
    </button>
    <micro-radio style="margin-left: 50px"
                 spacing="3px"
                 [label]="'Show Secure Access:'"
                 [options]="[
                             {positive: 'Assigned Users', negative: 'Assigned Users', value: 'true'},
                             {positive: 'Unassigned Users', negative: 'Unassigned Users', value: 'false'}
                             ]"
                 [(value)]="filter.hasService">
    </micro-radio>
  </div>
</div>

<mat-tab-group>
  <mat-tab label="Users">
    <div [ngClass]="{'padded': selectionMode!=='embedded'}">
      <!--  <mat-radio-group [(ngModel)]="selectedRow" (ngModelChange)="onSelectedRowChange()">-->
      <table class="basicTable">
        <thead>
        <tr>
          <th *ngIf="selectionMode" style="width: 14px;" rowspan="1"></th>
          <th>
            <div class="vbox">
              Company
              <micro-company-select *ngIf="auth.hasRole('COMPANY_ADMIN')"
                                    [(companyId)]="filter.companyId"
                                    [jump]="false">
              </micro-company-select>
              <micro-saHostCompany-select *ngIf="!auth.hasRole('COMPANY_ADMIN')"
                                          [(companyId)]="filter.companyId"
                                          [includeHosted]="true"
                                          [jump]="false">

              </micro-saHostCompany-select>
            </div>
          </th>
          <th>
            <div class="vbox">
              Department
              <micro-department-select [companyId]="filter.companyId"
                                       [(departmentId)]="filter.departmentId"
                                       [jump]="false">
              </micro-department-select>
            </div>
          </th>
          <th>
            <div class="vbox">
              Region
              <micro-region-select [companyId]="filter.companyId"
                                   [(regionId)]="filter.regionId"
                                   [jump]="false">
              </micro-region-select>
            </div>
          </th>
          <th>
            <div class="vbox">
              Username
              <input [(ngModel)]="filter.username">
            </div>
          </th>
          <th>
            <div class="vbox">
              Name
              <input [(ngModel)]="filter.name">
            </div>
          </th>
          <th>
            <div class="vbox">
              Email
              <input [(ngModel)]="filter.email">
            </div>
          </th>
          <th>
            <div class="vbox">
              MSISDN
              <input [(ngModel)]="filter.msisdn">
            </div>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let element of dataSource.data">
          <td *ngIf="selectionMode">
            <mat-checkbox [checked]="selectedUserIds.includes(element.id)" [value]="element.id"
                          (change)="onSelectUser($event)"></mat-checkbox>
          </td>
          <td>
            <micro-company-lookup [companyId]="element.companyId" [link]="true"></micro-company-lookup>
          </td>
          <td>
            <micro-department-lookup [departmentId]="element.departmentId" [link]="true"></micro-department-lookup>
          </td>
          <td>
            <micro-region-lookup *ngFor="let regionId of element.regionIds"
                                 [regionId]="regionId" [link]="true">

            </micro-region-lookup>
          </td>
          <td><a routerLink="/sa/users/{{element.id}}"
                 matTooltip="Jump to {{element.username}}">{{ element.username }}</a></td>
          <td>{{ element.firstName }} {{ element.lastName }}</td>
          <td>{{ element.email }}</td>
          <td>{{ element.msisdn }}</td>
        </tr>
        <tr *ngIf="dataSource.data?.length === 0">
          <td colspan="100"><em>No results found</em></td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td colspan="100">
            <mat-paginator #paginator
                           (page)="reload()">
            </mat-paginator>
          </td>
        </tr>
        </tfoot>
      </table>
    </div>
  </mat-tab>
  <mat-tab label="Secure Access Audit Log">
    <micro-saContactAuditLogs #auditLogs service="SITE_ACCESS" [embedded]="true"></micro-saContactAuditLogs>
  </mat-tab>
</mat-tab-group>
